$(document).ready(function () {

    $(".rating1").rateYo({
    rating: 2.5,
    starWidth: "24px",
    fullStar: true
    });

    if ($('#dreamhair').length) {

        $('#dreamhair').owlCarousel({
            loop: true,
            margin: 20,
            nav: true,
            dots: true,
            items: 3,
            responsive: {
                0: {
                    items: 1
                },
                767: {
                    items: 1
                },
                992: {
                    items: 3
                }
            }
        });

    }


    document.querySelectorAll(".stars").forEach(star => {
    const rating = parseFloat(star.dataset.rating);
    const percent = (rating / 5) * 100;

    star.querySelector(".stars-fill").style.width = percent + "%";
});


$(window).on("scroll", function(){

    if($(window).scrollTop() > 50){

        $("header").addClass("active");

        $(".topbar").stop(true,true).fadeOut(300);

    }else{

        $("header").removeClass("active");

        $(".topbar").stop(true,true).fadeIn(300);

    }

});

$(".hamburger").on("click", function(){

    $(this).toggleClass("active");

    $("nav").toggleClass("active");

    $("body").toggleClass("hidover");

});


    $(".accorddiv .accorddesc").hide();
    $(".accordshow .accorddesc").show();
    $(".accorddiv h3").on("click", function(){
        const parent = $(this).parent();
        if(parent.hasClass("accordshow")){
            parent.removeClass("accordshow");
            parent.find(".accorddesc").stop(true,true).slideUp(300);
        }else{
            $(".accorddiv").removeClass("accordshow");
            $(".accorddiv .accorddesc").stop(true,true).slideUp(300);
            parent.addClass("accordshow");
            parent.find(".accorddesc").stop(true,true).slideDown(300);
        }
    });

});